import { MatSelectionListChange, MatListOption, MatSelectionList, MatRadioChange, MatSnackBar } from '@angular/material';
import { CompanyService } from '@company/company.service';
import { Subscription, from } from 'rxjs';
import { ExceptionService } from '@exceptions-service';
import { HttpErrorResponse } from '@angular/common/http';
import { IModule, IErrorResponse, ITableauLink, ITableauWorkbook, IWorkbook } from '@interfaces';
import { ModuleService } from '@module/module.service';
import { WorkbookService } from '@workbook/workbook.service';
import { EMPTY, getNumber, loadInstanceOf } from '@utils';
import { ICompany } from '@company/company.structures';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { mergeMap } from 'rxjs/operators';
import { IGroup } from '@group/group.structure';

interface ILink {
  workbooks: [];
  groups: IGroup[];
}

interface IWorkbookThumb {
  id: number;
  tableau_id?: string;
  data_url?: string;
}

@Component({
  selector: 'app-link-groups',
  templateUrl: './link-groups.component.html',
  styleUrls: ['./link-groups.component.sass']
})
export class LinkGroupsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  private workbooks: ITableauWorkbook[];
  private modules: IModule[];
  private routeModuleId: number = EMPTY;
  private routeCompanyId: number = EMPTY;
  currentModule: IModule;
  currentCompany: ICompany;
  groups: [];
  companyWorkbooks: [];
  links: ITableauLink[];
  selectedWorbook: IWorkbook;
  data: ILink;
  lockGroups: boolean;
  showSpinner: boolean;
  companies: ICompany[];

  filterItems = '';
  p1 = 1;
  filterItems2 = '';
  p2 = 1;

  isProcessingImages = false;
  loadingWorkbooks = false;

  @ViewChild('items') public items;

  constructor(
    private snackBar: MatSnackBar,
    private moduleService: ModuleService,
    private exceptionService: ExceptionService,
    private companyService: CompanyService,
    private workbookService: WorkbookService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.showSpinner = false;
    this.lockGroups = true;
    this.subscriptions = [];
    this.workbooks = [];
    this.groups = [];
    this.companyWorkbooks = [];
    this.companies = [];
    this.links = [];
    this.currentModule = EMPTY;
    this.currentCompany = EMPTY;
    this.selectedWorbook = EMPTY;
    this.data = {
      workbooks: [],
      groups: [],
    };
    const statusSubs = this.companyService.observeStatusProcessingImg().subscribe(
      (res: boolean) => this.isProcessingImages = res,
      (err: HttpErrorResponse) => {
        this.isProcessingImages = false;
        console.log(err.message);
      }
    );

    const linksSubscription = this.companyService.observeTableauLinks().subscribe(
      (res: ITableauLink[]) => this.linksAdapter(res),
      (err: HttpErrorResponse) => { const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );

    const allModules = this.moduleService.observeModules().subscribe(
      (res: IModule[]) => {
        this.modules = res;
        this.loadModuleInfo();
      },
      (err: HttpErrorResponse) => { const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );

    this.subscriptions = [...this.subscriptions,
      statusSubs, linksSubscription, allModules,
    ];
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.routeModuleId = getNumber(params['id']);
      this.routeCompanyId = getNumber(params['companyId']);
    });
    this.loadModuleInfo();
    this.loadCompanyInfo();

    this.items.selectionChange.subscribe((s: MatSelectionListChange) => {
      this.lockGroups = true;
      this.showSpinner = true;
      const group: MatListOption = s.option;
      const isSelected = group.selected;
      const strAction = (isSelected) ? 'creado' : 'eliminado';
      const selected = {
        status: isSelected,
        value: group.value,
      };
      const worbookId = this.getWorkbookID();
      const link: ITableauLink = {
        group_id: selected.value['id'],
        workbook_id: worbookId,
      };

      this.companyService.updateTableauLink(link, selected.status, selected.value['tableau_id']).subscribe(
        (res) => {
          this.lockGroups = false;
          this.showSpinner = false;
          this.openSnackBar(`El vínculo ha sido ${strAction}.`, 'info');
        },
        (err: HttpErrorResponse) => {
          const error: IErrorResponse = this.exceptionService.errorHandling(err);
          this.lockGroups = false;
          this.showSpinner = false;
          this.openSnackBar('El vínculo NO se pudo crear, intente reiniciar la sesión', 'info');
        }
      );
    });
  }

  ngOnDestroy() {
    this.moduleService.setCompany(null);
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
  }

  manageTableauLinks = (tableauLinks: ITableauLink[]) => {
    // console.log(tableauLinks);
    this.loadingWorkbooks = false;
    this.companyService.refreshPreviewImages(this.currentCompany).subscribe(() => {});
  }

  private loadModuleInfo() {
    const module = loadInstanceOf(this.routeModuleId, this.modules as [], this.currentModule);
    if (module !== EMPTY) {this.moduleService.setCurrentModule(module); }
  }

  private loadCompanyInfo() {
    if (!isNaN(this.routeCompanyId)) {
      this.loadingWorkbooks = true;
      this.companyService.getCompany(this.routeCompanyId).pipe(
        mergeMap((company: ICompany) => {
          this.currentCompany = company;
          this.moduleService.setCompany(this.currentCompany);
          this.data = {
            groups: company.groups as IGroup[],
            workbooks: company.workbooks
          };
          return this.companyService.getTableauLinks(this.currentCompany);
        })
      ).subscribe(
        (tableauLinks: ITableauLink[]) => {
          this.loadingWorkbooks = false;
          this.companyService.refreshPreviewImages(this.currentCompany).subscribe(() => {});
        },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.loadingWorkbooks = false;
          const moduleId = String(this.router.url).split('/')[3];
          // this.router.navigate(['home/modules/', moduleId]);
        }
      );
    }
  }

  private getWorkbookID() {
    const isInvalidId = Number.isNaN(Number(this.selectedWorbook.id));

    if (isInvalidId) {
      return this.selectedWorbook.id;
    } else {
      return this.selectedWorbook.id;
    }
  }

  getLink(e: IWorkbook) {
    this.filterItems = '';
    this.selectedWorbook = e;
    this.lockGroups = false;
    const groupList: MatSelectionList = this.items;
    groupList.options.map((o: MatListOption) => {
      o.selected = false;
    });

    if (this.links.length) {
      const links = [...this.links];
      const groups = links.filter((tl: ITableauLink) =>
        (tl.workbook_id === e.id));

      groupList.options.map((o: MatListOption) => {
        const group = o.value;
        const matchedGroup = groups.filter((g) => g.group_id === group['id']);
        const checkedOption = (matchedGroup.length > 0);
        o.selected = checkedOption;
      });
    }
  }

  linksAdapter(links: ITableauLink[]) {
    this.links = links;
  }

  selectionChanged(mrChange: MatRadioChange) {
    const isChecked = mrChange.source.checked;
    const workbookSelected: IWorkbook = mrChange.value;

    const auxWorkboooks = [...this.data.workbooks];
    auxWorkboooks.map((w: Object) => { w['visible'] = false; });
    const selected: Object = auxWorkboooks.filter(w => w['id'] === workbookSelected.id)[0];
    selected['visible'] = true;
    this.getLink(workbookSelected);
  }

  processPreviewImages() {
    let thumbs = [];

    this.companyWorkbooks.map((cw: ITableauWorkbook) => {
      const thumb: IWorkbookThumb = {
        id: getNumber(cw.id), tableau_id: cw.tableau_id, data_url: '',
      };
      thumbs = [...thumbs, thumb];
    });

    from(thumbs)
    .pipe(mergeMap((r) => this.workbookService.getPreviewImage(r)), )
    .subscribe(
      (res: object) => {
        if (res !== EMPTY) {
          const auxCoWorkbooks: object[] = Array.from(this.companyWorkbooks);
          const objIndex = this.companyWorkbooks.findIndex((cw: ITableauWorkbook) => getNumber(cw.id) === getNumber(res['id']));
          auxCoWorkbooks[objIndex]['data_url'] = res['data_url'];
          this.companyWorkbooks = auxCoWorkbooks as [];
        }
        // console.log(auxCoWorkbooks);
        // if (typeof auxCoWorkbooks[0]['data_url'] !== 'undefined' && auxCoWorkbooks[0]['data_url'] !== EMPTY) {
        //   const imageUrl = auxCoWorkbooks[0]['data_url'];
        //   const image = new Image();
        //   image.height = 150;
        //   // image.title = file.name;
        //   image.src = imageUrl;
        //   if (String(imageUrl).length > 25) {
        //     // document.querySelector('#cvv').appendChild( image );
        //     const canvasElement = <HTMLCanvasElement> document.querySelector('#canvas-thumb');
        //     const canvasContext = canvasElement.getContext('2d');
        //     image.onload = function() {
        //       canvasContext.drawImage(image, 0, 0, 100, 100);
        //       // const image2 = canvasElement.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        //       // window.location.href = image2;
        //     };
        //   }
        // }
      },
      (err: HttpErrorResponse) => {
        const error: IErrorResponse = this.exceptionService.errorHandling(err);
      }
    );
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 2000,
    });
  }

  forceRefresh() {
    this.companyService.refreshPreviewImages(this.currentCompany, true).subscribe(
      res => {
        this.openSnackBar('Las miniaturas fueron actualizadas.', 'Reportes');
      },
      (e: HttpErrorResponse) => {
        this.isProcessingImages = false;
        this.openSnackBar('No se pudo refrescar las miniaturas.', 'Error');
        console.log(e.message);
      }
    );
  }
}
